import { __decorate } from "tslib";
import React, { Component } from 'react';
import defaultTo from 'lodash/defaultTo';
import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import isNil from 'lodash/isNil';
import sortBy from 'lodash/sortBy';
import { action, toJS } from 'mobx';
import { observer } from 'mobx-react';
import Tag from 'choerodon-ui/lib/tag';
import { pxToRem } from 'choerodon-ui/lib/_util/UnitConvertor';
import Animate from '../animate';
import Icon from '../icon';
import { $l } from '../locale-context';
import autobind from '../_util/autobind';
import { SelectionsPosition } from './enum';
export { SelectionsPosition, };
let SelectionList = class SelectionList extends Component {
    constructor() {
        super(...arguments);
        this.unSelect = (record) => {
            const { dataSet, treeFlag } = this.props;
            if (treeFlag === 'Y') {
                dataSet.treeUnSelect(record);
            }
            else {
                dataSet.unSelect(record);
            }
            if (!isUndefined(record.parent)) {
                dataSet.unSelect(record.parent);
            }
        };
        this.renderBelow = () => {
            const { dataSet, treeFlag, valueField = '', textField = '', selectionProps = {} } = this.props;
            const { nodeRenderer } = selectionProps;
            const records = (treeFlag === 'Y' ? dataSet.treeSelected : dataSet.selected).filter(record => !isNil(record.get(valueField)));
            if (isEmpty(records)) {
                return null;
            }
            const classString = `${this.prefixCls}-selection-list-below`;
            const animateChildren = this.getRecords(records).map((record) => {
                return (React.createElement("li", { key: record.get(valueField), className: `${classString}-item` },
                    React.createElement(Tag, { closable: record.selectable, onClose: () => {
                            this.unSelect(record);
                        } }, nodeRenderer ? toJS(nodeRenderer(record)) : React.createElement("span", null, record.get(textField)))));
            });
            return (React.createElement("div", { className: classString },
                React.createElement("p", { className: `${classString}-intro` }, $l('Lov', 'selection_tips', {
                    count: React.createElement("b", { key: "count" }, records.length),
                })),
                React.createElement(Animate, { className: `${classString}-list`, transitionAppear: true, transitionName: "fade", component: "ul" }, animateChildren)));
        };
    }
    get prefixCls() {
        const { context: { getProPrefixCls } } = this.props;
        return getProPrefixCls('modal');
    }
    contentRef(node) {
        this.selectionNode = node;
    }
    getRecords(records) {
        const { textField } = this.props;
        return sortBy(records, (item) => defaultTo(item.selectedTimestamp, -1), (item) => item.get(textField));
    }
    renderSide() {
        const { dataSet, treeFlag, valueField = '', textField = '', selectionProps = {} } = this.props;
        const { nodeRenderer, placeholder } = selectionProps;
        const records = (treeFlag === 'Y' ? dataSet.treeSelected : dataSet.selected).filter(record => !isNil(record.get(valueField)));
        const isEmptyList = isEmpty(records);
        if (isEmptyList && !placeholder) {
            return null;
        }
        const classString = `${this.prefixCls}-selection-list`;
        const animateChildren = this.getRecords(records).map((record) => {
            return (React.createElement("li", { key: record.get(valueField), className: `${classString}-item` },
                nodeRenderer ? toJS(nodeRenderer(record)) : React.createElement("span", null, record.get(textField)),
                React.createElement(Icon, { type: "cancel", onClick: () => {
                        this.unSelect(record);
                    } })));
        });
        return (React.createElement("div", { className: `${classString}-container`, ref: this.contentRef },
            React.createElement("p", { className: `${classString}-intro` }, isEmptyList ? placeholder : $l('Lov', 'selection_tips', {
                count: React.createElement("b", { key: "count" }, records.length),
            })),
            React.createElement(Animate, { className: `${classString}-list`, transitionAppear: true, transitionName: "slide-right", component: "ul" }, animateChildren)));
    }
    updateModalStyle() {
        if (!this.modalNode && this.selectionNode) {
            const { offsetParent } = this.selectionNode;
            if (this.selectionNode && offsetParent && offsetParent.parentNode) {
                const { parentNode } = offsetParent;
                this.modalNode = parentNode;
                const { width } = parentNode.getBoundingClientRect();
                Object.assign(parentNode.style, {
                    width: pxToRem(width + 300, true),
                });
            }
        }
        else if (this.modalNode && !this.selectionNode) {
            Object.assign(this.modalNode.style, {
                width: pxToRem(this.modalNode.offsetWidth - 300, true),
            });
            this.modalNode = null;
        }
    }
    componentDidMount() {
        this.updateModalStyle();
    }
    componentDidUpdate() {
        this.updateModalStyle();
    }
    render() {
        const { selectionsPosition } = this.props;
        if (selectionsPosition === SelectionsPosition.side) {
            return this.renderSide();
        }
        if (selectionsPosition === SelectionsPosition.below) {
            return this.renderBelow();
        }
        return null;
    }
};
__decorate([
    autobind
], SelectionList.prototype, "contentRef", null);
__decorate([
    action
], SelectionList.prototype, "unSelect", void 0);
SelectionList = __decorate([
    observer
], SelectionList);
export default SelectionList;
